import React from "react";

import { domToReact, Element as DomElement, DOMNode } from "html-react-parser";

import { getHtmlTagStyles } from "../utils/html-tag-styles";

/**
 * caption 태그를 경우에 따라 p 태그로 변환하여 렌더링
 *
 * table 내부의 caption: HTML 스펙을 따르기 위해 그대로 <caption>으로 유지
 * 그 외(단독 caption 등): div 안에 caption 을 두면 HTML 구조상 invalid 이므로 <p>로 변환
 */
export function renderCaption(element: DomElement): React.ReactElement {
  const parentName = (element as any)?.parent?.name as string | undefined;
  const children = domToReact((element.children as DOMNode[]) || [], {
    transform: undefined,
  });

  const captionClasses = getHtmlTagStyles("caption").join(" ");

  if (parentName === "table") {
    return <caption className={`${captionClasses}`}>{children}</caption>;
  }

  const pClasses = getHtmlTagStyles("p").join(" ");

  return <p className={`${pClasses}`}>{children}</p>;
}
